/* Bagsandlove – eigener Warenkorb-Einschub.
   Inhalt kommt aus sections/bl-cart-drawer.liquid (Section Rendering API), dadurch stimmen
   Preise, Rabatte (2er-Set) und Summen immer mit Shopify überein.
   Öffnet sich: beim Klick auf das Warenkorb-Symbol, nach „In den Warenkorb“ (Theme-Ereignis cartUpdate)
   und über window.blCart.refresh({ open: true }) – z. B. aus bl-bundle.js. */
if (!customElements.get('bl-cart')) {
  customElements.define(
    'bl-cart',
    class BlCart extends HTMLElement {
      connectedCallback() {
        window.blCart = this;
        // Zum Anschauen/Testen: ?blc-reset=1 in der Adresse blendet weggeklickte Empfehlungen (✕) wieder ein
        if (new URLSearchParams(window.location.search).has('blc-reset')) {
          try {
            Object.keys(sessionStorage)
              .filter((k) => k.startsWith('blc-nudge-dismissed'))
              .forEach((k) => sessionStorage.removeItem(k));
          } catch (e) {}
        }
        this.root = window.Shopify?.routes?.root || '/';
        this.sectionIds = ['bl-cart-drawer', 'cart-icon-bubble'];
        if (this.isPage) this.applyDismissed();
        this.syncPopup();
        setInterval(() => this.syncPopup(), 5000);

        this.addEventListener('click', (event) => this.onClick(event));
        document.addEventListener('keyup', (event) => {
          if (event.key === 'Escape' && this.isOpen) this.close();
        });

        // Warenkorb-Symbol im Header öffnet den Einschub statt der Warenkorbseite
        document.addEventListener(
          'click',
          (event) => {
            const icon = event.target.closest('#cart-icon-bubble');
            if (!icon) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            this.open(icon);
          },
          true
        );

        // Den Theme-Hinweis „Zum Warenkorb hinzugefügt“ stilllegen – stattdessen öffnet sich dieser Einschub
        const muteNotification = () => {
          const note = document.querySelector('cart-notification');
          if (note) note.renderContents = () => {};
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', muteNotification);
        else muteNotification();

        // App „Essential“ (Sticky-Leiste) bleibt aktiv – ihr eigener Warenkorb-Einschub wird aber durch diesen ersetzt:
        // will die App ihren Einschub öffnen, schließen wir ihn sofort und öffnen stattdessen diesen.
        const takeOverApp = () => {
          const api = window.essentialCartApi;
          if (!api || api.__blCart) return;
          api.__blCart = true;
          api.openCart = () => this.refresh({ open: true, pop: true });
        };
        takeOverApp();
        window.addEventListener('load', takeOverApp);
        new MutationObserver(() => {
          takeOverApp();
          const html = document.documentElement;
          if (!html.classList.contains('essential-cart__open')) return;
          try {
            window.essentialCartApi?.closeCart?.();
          } catch (e) {}
          html.classList.remove('essential-cart__open');
          html.classList.add('essential-cart__closed');
          this.refresh({ open: true, pop: true });
        }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

        // Nach „In den Warenkorb“ im Theme (1 Tasche & alle anderen Produkte)
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event?.source === 'product-form') this.refresh({ open: true, pop: true });
          });
        }
      }

      get isOpen() {
        return this.classList.contains('is-open');
      }

      get inner() {
        return this.querySelector('.blc__inner');
      }

      // Warenkorb-Seite: Einschub steht als Seiteninhalt (Klasse blc--page) – nie „öffnen/schließen“, nie Scrollen sperren
      get isPage() {
        return this.classList.contains('blc--page');
      }

      open(trigger) {
        if (this.isPage) {
          this.applyDismissed();
          return;
        }
        this.trigger = trigger || document.activeElement;
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('blc-lock');
        this.applyDismissed();
        setTimeout(() => this.querySelector('.blc__x')?.focus({ preventScroll: true }), 320);
        document.dispatchEvent(new CustomEvent('bl-cart:open'));
      }

      close() {
        if (this.isPage) return;
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('blc-lock');
        this.trigger?.focus?.({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('bl-cart:close'));
      }

      onClick(event) {
        const t = event.target;
        if (t.closest('[data-blc-close]')) return this.close();

        const qtyBtn = t.closest('[data-blc-qty]');
        if (qtyBtn) {
          const line = Number(qtyBtn.closest('[data-line]')?.dataset.line);
          if (line) this.change(line, Math.max(0, Number(qtyBtn.dataset.blcQty)));
          return;
        }

        // Farbe einer Tasche im Warenkorb wechseln
        const swapToggle = t.closest('[data-blc-swap-toggle]');
        if (swapToggle) {
          const box = swapToggle.closest('.blc-item')?.querySelector('[data-blc-swap]');
          if (box) {
            box.hidden = !box.hidden;
            swapToggle.setAttribute('aria-expanded', String(!box.hidden));
          }
          return;
        }
        const swap = t.closest('.blc-swap__sw');
        if (swap) {
          if (swap.disabled || swap.getAttribute('aria-pressed') === 'true') return;
          const item = swap.closest('.blc-item');
          const qty = Number(item.querySelector('.blc-qty span')?.textContent) || 1;
          this.swap(Number(item.dataset.variantId), Number(swap.dataset.variantId), qty);
          return;
        }

        const sw = t.closest('.blc-sw');
        if (sw && !sw.disabled) {
          const nudge = sw.closest('[data-blc-nudge]');
          nudge.querySelectorAll('.blc-sw').forEach((s) => s.setAttribute('aria-checked', String(s === sw)));
          const add = nudge.querySelector('[data-blc-add]');
          add.dataset.variantId = sw.dataset.variantId;
          add.querySelector('[data-blc-add-label]').textContent = sw.dataset.label;
          // Herz-Karte: großes Bild folgt der gewählten Farbe
          nudge.querySelectorAll('[data-blc-hook-img]').forEach((img) => (img.hidden = img.dataset.blcHookImg !== sw.dataset.variantId));
          return;
        }

        const add = t.closest('[data-blc-add]');
        if (add) return this.add(Number(add.dataset.variantId));

        const dismiss = t.closest('[data-blc-dismiss]');
        if (dismiss) {
          try {
            sessionStorage.setItem(this.dismissKey(dismiss.closest('[data-blc-nudge]')), '1');
          } catch (e) {}
          this.applyDismissed();
        }
      }

      // Jeder Hinweis (2. Tasche, Herz-Taschenhalter) lässt sich einzeln für die Sitzung wegklicken
      dismissKey(nudge) {
        const name = nudge?.dataset.blcNudge;
        return name && name !== 'pp3' ? `blc-nudge-dismissed-${name}` : 'blc-nudge-dismissed';
      }

      applyDismissed() {
        this.querySelectorAll('[data-blc-nudge]').forEach((nudge) => {
          let dismissed = false;
          try {
            dismissed = sessionStorage.getItem(this.dismissKey(nudge)) === '1';
          } catch (e) {}
          // Nachrücker (z. B. Bär nach dem Herz): erscheint erst, wenn der vorige Hinweis weggeklickt wurde
          const after = nudge.dataset.blcAfter;
          const prev = after && this.querySelector(`[data-blc-nudge="${after}"]`);
          if (!dismissed && prev) {
            let prevDismissed = false;
            try {
              prevDismissed = sessionStorage.getItem(this.dismissKey(prev)) === '1';
            } catch (e) {}
            if (!prevDismissed) dismissed = true;
          }
          nudge.hidden = dismissed;
        });
      }

      setBusy(busy) {
        this.inner?.classList.toggle('is-busy', busy);
      }

      async refresh({ open = false, pop = false } = {}) {
        const res = await fetch(`${this.root}?sections=${this.sectionIds.join(',')}`);
        this.render(await res.json(), pop);
        if (open && !this.isOpen) this.open();
      }

      async change(line, quantity) {
        this.setBusy(true);
        try {
          const res = await fetch(`${this.root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line, quantity, sections: this.sectionIds, sections_url: window.location.pathname }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message);
          this.render(data.sections);
          this.publish();
        } catch (error) {
          alert(error.message || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.');
          this.refresh();
        } finally {
          this.setBusy(false);
        }
      }

      // Variante tauschen: erst neue Farbe in gleicher Menge hinzufügen, dann die alte Farbe um dieselbe Menge verringern –
      // so geht nichts verloren, falls etwas schiefgeht
      async swap(oldId, id, quantity) {
        if (!oldId || !id) return;
        this.setBusy(true);
        const post = (url, body) =>
          fetch(`${this.root}${url}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
        try {
          const added = await post('cart/add.js', { items: [{ id, quantity }] });
          if (!added.ok) throw new Error((await added.json()).description);
          // Zeilen-Schlüssel können sich durch Rabatte ändern – darum die alte Zeile frisch aus dem Warenkorb suchen
          const cart = await (await fetch(`${this.root}cart.js`)).json();
          const old = cart.items.find((i) => i.variant_id === oldId);
          if (!old) throw new Error();
          const res = await post('cart/change.js', { id: old.key, quantity: Math.max(0, old.quantity - quantity), sections: this.sectionIds, sections_url: window.location.pathname });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message);
          this.render(data.sections);
          this.publish();
        } catch (error) {
          alert(error.message || 'Die Farbe ließ sich leider nicht ändern. Bitte versuche es noch einmal.');
          this.refresh();
        } finally {
          this.setBusy(false);
        }
      }

      async add(id) {
        if (!id) return;
        this.setBusy(true);
        try {
          const res = await fetch(`${this.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: this.sectionIds, sections_url: window.location.pathname }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message);
          this.render(data.sections, true);
          this.publish();
        } catch (error) {
          alert(error.message || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.');
        } finally {
          this.setBusy(false);
        }
      }

      // Andere Bausteine (z. B. Warenkorbseite) über die Änderung informieren
      publish() {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bl-cart' });
        }
      }

      // Newsletter-Popup (Shopify Forms 563100) nicht zeigen, solange etwas im Warenkorb liegt (04.11.2026).
      // Nicht auf /pages/: dort steht das Widerrufsformular, das dieselbe App nutzt.
      syncPopup() {
        const filled = !!this.querySelector('.blc-item') && !window.location.pathname.includes('/pages/');
        document.documentElement.classList.toggle('bl-no-popup', filled);
        if (!filled) return;
        try {
          const session = localStorage.getItem('forms_session_id');
          if (session) localStorage.setItem('563100-dismissed-in-session', session);
        } catch (e) {}
      }

      render(sections, pop = false) {
        if (!sections) return;
        const parse = (html) => new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');

        const drawer = sections['bl-cart-drawer'] && parse(sections['bl-cart-drawer']);
        const target = this.querySelector('#shopify-section-bl-cart-drawer');
        if (drawer && target) target.innerHTML = drawer.innerHTML;
        this.applyDismissed();
        this.syncPopup();

        const bubble = sections['cart-icon-bubble'] && parse(sections['cart-icon-bubble']);
        const icon = document.getElementById('cart-icon-bubble');
        if (bubble && icon) {
          icon.innerHTML = bubble.innerHTML;
          if (pop) {
            icon.classList.remove('blc-pop');
            void icon.offsetWidth;
            icon.classList.add('blc-pop');
          }
        }
      }
    }
  );
}
